import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useState, } from "react";
/**
 * Context that holds active gateways
 */
export const GatewaysContext = createContext(new Map());
GatewaysContext.displayName = "GatewaysContext";
/**
 * Context for adding gateways
 */
export const AddGatewayContext = createContext(() => undefined);
AddGatewayContext.displayName = "AddGatewayContext";
/**
 * Context for removing gateways
 */
export const RemoveGatewayContext = createContext(() => undefined);
RemoveGatewayContext.displayName = "RemoveGatewayContext";
/**
 * Manages elements for the gateway mechanism (createPortal)
 * @param props
 * @returns
 */
export function GatewayProvider(props) {
    const [gateways, setGateways] = useState(() => new Map());
    const addGateway = useCallback((name, element) => {
        setGateways((previous) => {
            const next = new Map(previous);
            next.set(name, element);
            return next;
        });
    }, []);
    const removeGateway = useCallback((name) => {
        setGateways((previous) => {
            const next = new Map(previous);
            next.delete(name);
            return next;
        });
    }, []);
    return (_jsx(GatewaysContext.Provider, { value: gateways, children: _jsx(AddGatewayContext.Provider, { value: addGateway, children: _jsx(RemoveGatewayContext.Provider, { value: removeGateway, children: props.children }) }) }));
}
//# sourceMappingURL=GatewayProvider.js.map